const CALLABLE_PREFIX = '';
export const getTrackAndTraceCompany = (functions) => {
  return functions.httpsCallable(CALLABLE_PREFIX + 'getTrackAndTraceCompany');
};

export const getOrderStatus = (functions) => {
  return functions.httpsCallable(CALLABLE_PREFIX + 'getOrderStatus');
};